import { render, staticRenderFns } from "./msgBox.vue?vue&type=template&id=0669ff50&"
import script from "./msgBox.vue?vue&type=script&lang=js&"
export * from "./msgBox.vue?vue&type=script&lang=js&"
import style0 from "./msgBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports